import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { CreateParticipantTasksFromTemplates } from '../mutations/createParticipantTaskFromTemplates.mutation';
import type {
  CreateParticipantTasksFromTemplatesMutation,
  CreateParticipantTasksFromTemplatesMutationVariables,
} from '../types';

export const useCreateParticipantTasksFromTemplatesMutation = (
  options?: MutationOptions<
    CreateParticipantTasksFromTemplatesMutation,
    CreateParticipantTasksFromTemplatesMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(CreateParticipantTasksFromTemplates), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('tasks'),
      });
    },
  });
};
